<template>
  <div class="tile-container">
    <div
      class="participant-option single-modal"
      :key="participant.user_id"
      :class="{
        active:
          $store.state.shown_modal_name ==
          'participant_' + participant.user_id + '_options_modal',
      }"
      @click.stop
    >
      <div class="modal_userinfo">
        <div class="avatar">{{ initials }}</div>

        <div class="name">
          {{ participant.user_name }}
          {{ participant.local ? "(you)" : "" }}
          {{ participant.owner ? "(admin)" : "" }}
        </div>
      </div>

      <div class="volume_meter_wrap">
        <img
          src="@/assets/img/volume_down_icon.svg"
          alt=""
          class="hover_op"
          @click="volume = parseFloat((volume - 0.1).toFixed(1))"
        />

        <!-- <vue-range-slider
          ref="slider"
          :min="0"
          :max="1"
          :step="0.1"
          :width="246"
          :height="8"
          :tooltip="null"
          :dot="'disabled'"
          v-model="volume"
        ></vue-range-slider> -->

        <img
          src="@/assets/img/volume_up_icon.svg"
          alt=""
          class="hover_op"
          @click="volume = parseFloat((volume + 0.1).toFixed(1))"
        />
      </div>

      <div class="maximize-options">
        <button
          class="options-text"
          @click="
            $store.commit('maximizeUserCallArea'), (is_maximized = true), hide()
          "
          v-if="!$store.state.user_maximized"
        >
          <h4>Maximize</h4>
        </button>

        <button
          class="options-text"
          @click="
            $store.commit('minimizeUserCallArea'),
              (is_maximized = false),
              hide()
          "
          v-if="$store.state.user_maximized"
        >
          <h4>Minimize</h4>
        </button>

        <button
          class="options-text"
          :class="participant.local ? 'mb-32' : ''"
          @click="togglefullscreen(), hide()"
        >
          <h4>Fullscreen</h4>
        </button>

        <div class="divider" v-if="!participant.local"></div>

        <button
          class="options-text"
          v-if="participant.video.state != 'off' && !participant.local"
          @click="ParticipantCameraOff(participant.userId), hide()"
        >
          <h4>Turn camera off</h4>
        </button>

        <button
          class="options-text"
          v-if="participant.video.state === 'off' && !participant.local"
          @click="ParticipantCameraOn(participant.userId), hide()"
        >
          <h4>Turn camera on</h4>
        </button>

        <button
          class="options-text"
          @click="muteParticipant(participant), hide()"
          v-if="participant.audio.state !== 'off' && !participant.local"
        >
          <h4>Turn microphone off</h4>
        </button>

        <button
          class="options-text"
          @click="unmuteParticipant(participant), hide()"
          v-if="participant.audio.state === 'off' && !participant.local"
        >
          <h4>Turn microphone on</h4>
        </button>

        <button
          class="options-text mb-32"
          @click="eject(participant.userId), hide()"
          v-if="!participant.local"
        >
          <h4>Kick</h4>
        </button>
      </div>
      <!-- <a
        href="/auth/login"
        target="_blank"
        class="settings_apply color_btn hover_op"
        @click="$store.commit('hideModal')"
        v-if="authenticated == false"
      >
        Upgrade
      </a> -->
    </div>

    <div
      class="video-content"
      :style="{ height: isInLobby && lobbyVideoContentHeight }"
    >
      <VideoTrack
        :rotate="participant.local"
        v-if="participant.video"
        :track="video"
      />

      <div v-else>
        <participant-avatar :participant="participant" />
      </div>
    </div>

    <div class="tile-info">
      <div v-if="muted" class="muted-logo">
        <img
          src="../../assets/img/microphone_off.svg"
          style="width: 16px; height: 16px"
        />
      </div>
      <div class="participant-tile-name">
        <h4 class="participant-tile-text">
          {{ participant.user_name }} {{ participant.owner ? "(you)" : "" }}
        </h4>
      </div>
    </div>

    <div v-if="participant.screen">Sharing screen</div>

    <AudioTrack v-if="!participant.local && participant.audio" :track="audio" />

    <div v-if="transcript" style="color: white">{{ transcript }}</div>

    <div
      v-if="status === 'joined'"
      class="dots-menu"
      @click="showOptionsModal()"
    >
      <img
        src="../../assets/img/menu_icon.svg"
        style="width: 24px; height: 24px"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import VideoTrack from "./VideoTrack.vue";
import AudioTrack from "./AudioTrack.vue";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
import ParticipantAvatar from "./ParticipantAvatar";

export default {
  components: { ParticipantAvatar, AudioTrack, VideoTrack, VueRangeSlider },
  props: ["participant", "participantsNumber"],
  name: "ParticipantTile",

  data() {
    return {
      transcript: "",
      transcriptDismissTimeout: null,
      show_drop: false,
      volume: 0.5,
      is_maximized: false,
      fullscreen: false,
      teleport: true,
      tileContainerHeightAfter640HeightBreakpoint: null,
      lobbyVideoContentHeight:
        window.innerHeight - 64 - 24 - 16 - 160 - 32 - 96 - 32 + "px",
    };
  },

  watch: {
    volume: function () {
      if (this.volume > 1) {
        this.volume = 1;
      } else if (this.volume < 0) {
        this.volume = 0;
      }
    },
  },

  mounted() {
    window.addEventListener("resize", this.resizeEvent);
  },

  computed: {
    initials() {
      const [firstName, lastName] = this.participant.user_name
        .toUpperCase()
        .split(" ");
      const firstLetter = firstName[0];
      const secondLetter = lastName ? lastName[0] : firstName[1];
      return `${firstLetter}${secondLetter}`;
    },
    muted() {
      return this.participant.audio === false;
    },
    audio() {
      return this.participant.audioTrack;
    },
    video() {
      return this.participant.videoTrack;
    },
    meetingState() {
      return this.$store.state.meeting.meeting;
    },
    authenticated() {
      return this.$store.state.userAuthenticated;
    },
    status() {
      return this.$store.state.meeting.status;
    },
    isInLobby() {
      return this.$store.getters.isInLobby;
    },
  },

  methods: {
    muteParticipant(participant) {
      this.$store.dispatch("participantAudio", { participant, enable: false });
    },

    unmuteParticipant(participant) {
      this.$store.dispatch("participantAudio", { participant, enable: false });
    },

    showOptionsModal() {
      this.$store.commit(
        "showModal",
        `participant_${this.participant.user_id}_options_modal`
      );
    },

    togglefullscreen() {
      this.fullscreen = !this.fullscreen;
    },

    toggleApi() {
      this.$fullscreen.toggle(this.$el.querySelector(".fullscreen_wrapper"), {
        teleport: this.teleport,
        callback: (isFullscreen) => {
          this.fullscreen = isFullscreen;
        },
      });
    },

    hide() {
      this.show_drop = false;
    },

    resizeEvent() {
      if (window.innerWidth < 768) {
        this.lobbyVideoContentHeight =
          window.innerHeight - 64 - 24 - 16 - 160 - 32 - 96 - 32 + "px";
      } else {
        this.lobbyVideoContentHeight =
          window.innerHeight - 64 - 24 - 16 - 32 - 96 - 32 + "px";
      }
    },
  },
};
</script>

<style lang="scss">
.volume_meter_wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 16px;
  padding: 0 !important;

  @media all and (max-width: 815px) {
    margin-bottom: 16px;
    margin-left: 16px;
    margin-right: 16px;
  }

  img {
    height: 24px;
    cursor: pointer;
  }
}

.vue-range-slider {
  padding: 0 !important;
  margin: 0 !important;
  width: 246px;

  .slider-dot {
    display: none;
  }

  .slider {
    padding: 0 !important;
  }

  &.slider-component .slider .slider-process {
    background-color: #000;
    padding: 0 !important;
  }
}

.single-modal {
  position: absolute;
  background-color: #fff;
  opacity: 0;
  pointer-events: none;
  display: none;
  transition: opacity 360ms;
  display: flex;
  flex-direction: column;
  width: 422px;
  border-radius: 16px;
  padding: 27px 32px 32px;

  @media all and (max-width: 769px) {
    padding: 16px;
  }

  @media all and (max-width: 767px) {
    width: calc(100% - 32px);
  }

  &.active {
    display: flex;
    opacity: 1;
    pointer-events: all;
    transition: opacity 360ms;
  }

  .maximize-options {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
    align-items: flex-start;

    .options-text {
      width: 100%;
      cursor: pointer;
      margin-top: 16px;
    }

    h4 {
      font-family: "NunitoSans-Regular";
      font-size: 16px;
      font-weight: 400;
      font-style: normal;
      letter-spacing: 0px;
      text-align: left;
      line-height: 24px;
      padding-left: 32px;
    }
  }

  .inner {
    flex: 1 1 auto;
    margin-top: 0;
    margin-bottom: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 0px;
    }
  }

  .transparent_btn {
    margin-top: 16px;
  }

  p + .color_btn {
    margin-top: 0;
  }
}

.modal_userinfo {
  display: flex;
  align-items: center;

  & + .modal_userinfo {
    margin-top: 16px;
  }

  .avatar {
    font-weight: 400;
    line-height: 24px;
    margin-right: 16px;
  }

  .name {
    flex: 1 1 auto;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .call_more {
    height: 40px;
    flex: none;
    display: flex;
    align-items: center;
  }

  padding: 32px 32px 0 !important;
}

.modal_overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.32);
  opacity: 0;
  pointer-events: none;
  transition: opacity 360ms;
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;
  display: none;

  .logo_line {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    margin-top: 32px;
  }

  .remove_btn {
    display: flex;
    align-items: center;

    img {
      margin-left: 16px;
    }
  }

  .room_counter {
    margin-bottom: 32px;
    text-align: center;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 22px;
      margin-right: 16px;
    }
  }

  .checkbox_wrap {
    margin-top: 32px;

    input {
      display: none;
    }

    label {
      cursor: pointer;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 24px;
      text-align: left;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
        margin-right: 16px;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 4px;
      }
    }
  }

  &.active {
    display: block;
    opacity: 1;
    pointer-events: all;
    transition: opacity 360ms;
  }

  .headin {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 27px;

    @media all and (max-width: 767px) {
      margin-bottom: 16px;
    }

    & + .subtitle {
      margin-top: 0;
    }

    p,
    button {
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 0;
    }

    button {
      display: flex;
      align-items: center;

      span {
        cursor: pointer;

        @media all and (max-width: 767px) {
          display: none;
        }
      }

      img {
        margin-left: 10px;
      }
    }
  }

  .colored_btn,
  .color_btn {
    font-size: 16px;
    margin-top: 32px;
    flex: none;

    & + .error_notificatin {
      margin-top: 32px;
    }

    &.join_btn {
      margin-top: 0;
      margin-bottom: 0;

      & + .join_btn {
        margin-top: 16px;
      }
    }
  }
}
</style>

<style scoped lang="scss">
#initials {
  color: #fff;
  border-radius: 16px;
  opacity: 1;
  background-color: rgba(1, 94, 93, 1);
  width: 64px;
  height: 64px;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}

.video-content {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
}

.tile-container {
  border-radius: 16px;
  opacity: 1;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 !important;

  max-width: 288px;
  margin-right: auto;
  margin-left: auto;

  @media screen and (min-width: 768px) {
    max-width: unset;
  }
}

.dots-menu {
  color: #fff;
  text-align: right;
  padding: 8px 16px 0px 0px;
  height: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: absolute;
  right: 21px;
  top: 8px;
  padding: 0 !important;
}

.participant-option {
  right: 16px;
  top: 56px;
  z-index: 1111;
  padding: 0 !important;
}

.participants-2 {
  /* width: 696px;
  height: 522px;
  /* padding: 181px 308px !important; */
}

.participants-4 {
  /* width: 528px;
  height: 396px; */
  padding: 118px 224px;
}

.participants-8 {
  /* width: 340px;
  height: 255px; */
  padding: 48px 130px;
}

.participant-tile-name {
  border-radius: 8px;
  background-color: rgba(255, 254, 255, 1);
}

.tile-info {
  display: flex;
  position: absolute;
  height: 24px;
  left: 8px;
  bottom: 8px;

  gap: 0.5rem;

  @media screen and (min-width: 1280px) {
    left: 16px;
    bottom: 16px;
  }
}

.muted-logo {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #fc5a12;
  border-radius: 8px;
}

.participant-tile-text {
  padding: 4px 8px;
  opacity: 1;
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0px;
  text-align: left;
  line-height: 16px;
}

.options-text:hover {
  background-color: #f9f4ef;
}

.mb-32 {
  margin-bottom: 32px;
}

.divider {
  width: 358px;
  height: 1px;
  background-color: rgba(0, 0, 0, 1);
  margin: 16px 32px 0 !important;
  padding: 0 !important;
  opacity: 0.16;
}
</style>
